import { createContext, useContext, useState, useCallback, type PropsWithChildren } from 'react';

interface ChatDrawerContextValue {
  isOpen: boolean;
  activeSessionId: string | null;
  openDrawer: () => void;
  closeDrawer: () => void;
  setActiveSessionId: (id: string | null) => void;
}

const ChatDrawerContext = createContext<ChatDrawerContextValue | null>(null);

export const ChatDrawerProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSessionId, setActiveSessionId] = useState<string | null>(null);

  const openDrawer = useCallback(() => {
    setIsOpen(true);
  }, []);
  const closeDrawer = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <ChatDrawerContext.Provider
      value={{ isOpen, activeSessionId, openDrawer, closeDrawer, setActiveSessionId }}
    >
      {children}
    </ChatDrawerContext.Provider>
  );
};

export const useChatDrawer = (): ChatDrawerContextValue => {
  const context = useContext(ChatDrawerContext);
  if (!context) {
    throw new Error('useChatDrawer must be used within a ChatDrawerProvider');
  }
  return context;
};
